/**
 * 移动端主题
 */
import type { Theme } from '../../core/theme';
import { axisPointerThemeParse } from './component/axisPointer';
import { barThemeParse } from './series/bar';
import { lineThemeParse } from './series/line';
import { treemapThemeParse } from './series/treemap';
import { sankeyThemeParse } from './series/sankey';
import { dvScatterThemeParse } from './series/dvScatter';
import { dvMarkerThemeParse } from './series/dvMarker';
import { darkThemeParse as dvTwoWayTreeDarkThemeParse } from './series/dvTwoWayTree';
import { dataZoomThemeParse } from './component/dataZoom';
import { graphicParse } from './component/graphic';
import defaultThemeConfig from '../util/presetOptionToken';
import { dynamicBarThemeParse } from '../pc/series/dynamicBar';
import { dvRadarThemeParse } from './series/dvRadar';
import { AIGCTokenLight } from '../config/presetAIGCToken';

export const mobileAppLight = {
  name: 'mobile-app-light' as const,
  presetOptionToken: defaultThemeConfig.shouchao,
  parsers: [
    // series -------------------------------------------------------
    dynamicBarThemeParse,
    barThemeParse,
    lineThemeParse,
    treemapThemeParse,
    sankeyThemeParse,
    dvScatterThemeParse,
    dvMarkerThemeParse,
    dvRadarThemeParse,

    // component -------------------------------------------------------
    axisPointerThemeParse,
    dataZoomThemeParse,
    graphicParse
  ],
  token: AIGCTokenLight
} as Theme;

export const mobileAppDark = {
  name: 'mobile-app-dark' as const,
  presetOptionToken: defaultThemeConfig.shouchao,
  parsers: [
    // series -------------------------------------------------------
    barThemeParse,
    lineThemeParse,
    dvTwoWayTreeDarkThemeParse,
    dvScatterThemeParse,
    dvMarkerThemeParse,
    dvRadarThemeParse,

    // component -------------------------------------------------------
    dataZoomThemeParse,
    axisPointerThemeParse,
    graphicParse
  ]
} as Theme;
